import React from "react";
import { Route, Switch, useLocation, useRouteMatch } from "react-router-dom";
import ChosenProduct from "./ChosenProduct";
import Products from "./Products";
import "../../../css/products.css";
import {CartItem} from "../../../lib/types/search"

interface ProductsPageProps {
  onAdd: (item: CartItem) => void;
}

export default function ProductPage(props:ProductsPageProps) {
  const {onAdd} = props;
  const products = useRouteMatch();
  console.log("products", products)
  return(
    <div className={"products-page"}>
      <Switch>
        <Route path={`${products.path}/:productId`}>
           <ChosenProduct onAdd= {onAdd}/>
        </Route>
        <Route>
          <Products onAdd={onAdd}/>
        </Route>
      </Switch>
    </div>
  );
}